import { render, staticRenderFns } from "./MatchDetail.vue?vue&type=template&id=fa1045fe&scoped=true&"
import script from "./MatchDetail.vue?vue&type=script&lang=js&"
export * from "./MatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./MatchDetail.vue?vue&type=style&index=0&id=fa1045fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1045fe",
  null
  
)

export default component.exports